import { useContext } from 'react'
import { UserContext } from '../context/UserContext'

export default () => {
  return useContext(UserContext)
}
